'use client'

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Spacer } from '@vinted/web-ui'

import {
  WalletConversionStatus,
  getWalletConversionStatus,
} from '@marketplace-web/domain/business-accounts-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import { MEMBER_PROFILE_URL } from 'constants/routes'
import { redirectToPage } from '@marketplace-web/shared/browser'

import { useSession } from '@marketplace-web/shared/session'

import { ROUTES } from '../../../constants/routes'
import ConversionForm from './ConversionForm'
import PendingState from './PendingState'
import FailedState from './FailedState'

const WalletConversion = () => {
  const navigate = useNavigate()
  const { user } = useSession()
  const userId = user?.id
  const isDsaFlowEnabled = useFeatureSwitch('dsa_business_account_registration')
  const isUnverifiedStatusEnabled = useFeatureSwitch(
    'unverified_business_account_conversion_status_enabled',
  )

  const [conversionStatus, setConversionStatus] = useState<WalletConversionStatus>()

  useEffect(() => {
    async function fetchConversionStatus() {
      const response = await getWalletConversionStatus()

      if ('errors' in response) return

      setConversionStatus(response.state || WalletConversionStatus.Idle)
    }

    fetchConversionStatus()
  }, [])

  useEffect(() => {
    if (!userId) return

    if (isUnverifiedStatusEnabled) {
      if (isDsaFlowEnabled && conversionStatus === WalletConversionStatus.Unverified) {
        navigate(ROUTES.KYB_FORM)
      } else if (conversionStatus === WalletConversionStatus.Completed) {
        redirectToPage(MEMBER_PROFILE_URL(userId))
      }
    } else {
      if (conversionStatus !== WalletConversionStatus.Completed) return
      if (isDsaFlowEnabled) {
        navigate(ROUTES.KYB_FORM)
      } else {
        redirectToPage(MEMBER_PROFILE_URL(userId))
      }
    }
  }, [conversionStatus, userId, isDsaFlowEnabled, navigate, isUnverifiedStatusEnabled])

  function handleStatusChange(status: WalletConversionStatus) {
    setConversionStatus(status)
  }

  function renderContent() {
    switch (conversionStatus) {
      case WalletConversionStatus.Idle:
        return <ConversionForm onStatusChange={handleStatusChange} />
      case WalletConversionStatus.Pending:
        return <PendingState onStatusChange={handleStatusChange} />
      case WalletConversionStatus.Failed:
        return <FailedState />
      default:
        return null
    }
  }

  return (
    <div className="container ">
      <div className="u-flexbox u-justify-content-center u-flex-direction-column">
        <Spacer size={Spacer.Size.X3Large} />
        {renderContent()}
      </div>
    </div>
  )
}

export default WalletConversion
